<script setup>
import { inject, computed } from 'vue'

defineProps({
  item: {
    type: Object,
    required: true
  }
})

const checkSubscription = inject('checkSubscription')

function countryCodeToFlagEmoji (code) {
  return code
    .toUpperCase()
    .replace(/./g, char =>
      String.fromCodePoint(char.charCodeAt(0) + 127397)
    )
}

const countryFlags = computed(() =>
  new Map([
    ['RU', countryCodeToFlagEmoji('RU')], // Russia
    ['US', countryCodeToFlagEmoji('US')], // United States
    ['GB', countryCodeToFlagEmoji('GB')], // United Kingdom
    ['FR', countryCodeToFlagEmoji('FR')], // France
    ['DE', countryCodeToFlagEmoji('DE')], // Germany
    ['IT', countryCodeToFlagEmoji('IT')], // Italy
    ['ES', countryCodeToFlagEmoji('ES')], // Spain
    ['PT', countryCodeToFlagEmoji('PT')], // Portugal
    ['NL', countryCodeToFlagEmoji('NL')], // Netherlands
    ['BE', countryCodeToFlagEmoji('BE')], // Belgium
    ['CH', countryCodeToFlagEmoji('CH')], // Switzerland
    ['SE', countryCodeToFlagEmoji('SE')], // Sweden
    ['NO', countryCodeToFlagEmoji('NO')], // Norway
    ['DK', countryCodeToFlagEmoji('DK')], // Denmark
    ['FI', countryCodeToFlagEmoji('FI')], // Finland
    ['PL', countryCodeToFlagEmoji('PL')], // Poland
    ['CZ', countryCodeToFlagEmoji('CZ')], // Czechia
    ['AT', countryCodeToFlagEmoji('AT')], // Austria
    ['HU', countryCodeToFlagEmoji('HU')], // Hungary
    ['GR', countryCodeToFlagEmoji('GR')], // Greece
    ['TR', countryCodeToFlagEmoji('TR')], // Turkey
    ['IL', countryCodeToFlagEmoji('IL')], // Israel
    ['UA', countryCodeToFlagEmoji('UA')], // Ukraine
    ['JP', countryCodeToFlagEmoji('JP')], // Japan
    ['CN', countryCodeToFlagEmoji('CN')], // China
    ['KR', countryCodeToFlagEmoji('KR')], // South Korea
    ['IN', countryCodeToFlagEmoji('IN')], // India
    ['BR', countryCodeToFlagEmoji('BR')], // Brazil
    ['AR', countryCodeToFlagEmoji('AR')], // Argentina
    ['MX', countryCodeToFlagEmoji('MX')], // Mexico
    ['CA', countryCodeToFlagEmoji('CA')], // Canada
    ['AU', countryCodeToFlagEmoji('AU')], // Australia
    ['NZ', countryCodeToFlagEmoji('NZ')], // New Zealand
    ['ZA', countryCodeToFlagEmoji('ZA')], // South Africa
    ['EG', countryCodeToFlagEmoji('EG')], // Egypt
    ['NG', countryCodeToFlagEmoji('NG')], // Nigeria
    ['KE', countryCodeToFlagEmoji('KE')], // Kenya
    ['SA', countryCodeToFlagEmoji('SA')], // Saudi Arabia
    ['AE', countryCodeToFlagEmoji('AE')] // United Arab Emirates
  ])
)
</script>

<template>
  <div
    class="flex gap-1 items-center"
    :class="{ 'blur-md select-none py-2': checkSubscription(item) }">
    <span v-if="item.value && countryFlags.get(item.value.countryCode)">
      {{ countryFlags.get(item.value.countryCode) }}
    </span>

    <span class="text-sm text-gray-500 not-italic capitalize">
      {{ checkSubscription(item) ? 'Secret text' : item.value.name }}
    </span>
  </div>
</template>